module.exports = __webpack_public_path__ + "img/合约调用.16713221.jpg";